import { cn } from "../../../utils";

const NUM_COLUMNS = 6;
const NUM_ROWS = 5;
const ACTION_COL_WIDTH = "w-50"; // 👈 fixed width for action column

type TTableListingLoadersProps = {
  tdClassName?: string;
  thClassName?: string;
  borderSpacingY?: string;
  numOfRows?: number;
  numOfColumns?: number;
};

const TableListingLoaders = ({
  tdClassName,
  thClassName,
  borderSpacingY,
  numOfColumns = NUM_COLUMNS,
  numOfRows = NUM_ROWS,
}: TTableListingLoadersProps) => {
  const totalColumns = numOfColumns + 1; // action column

  return (
    <div className="overflow-x-auto w-full">
      <table
        data-testid="table-listing-loaders"
        className={cn(
          "w-full border-separate border-spacing-y-2 animate-pulse table-fixed",
          borderSpacingY,
        )}
      >
        {/* HEADER */}
        <thead>
          <tr>
            {Array.from({ length: totalColumns }).map((_, idx) => (
              <th
                key={idx}
                className={cn(
                  "px-4 py-4",
                  idx === totalColumns - 1 && ACTION_COL_WIDTH, // 👈 constrain header
                  thClassName,
                )}
              >
                <div
                  data-testid="header-skeleton"
                  className="h-8 w-full bg-gray/30 rounded"
                />
              </th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody>
          {Array.from({ length: numOfRows }).map((_, rowIdx) => (
            <tr key={rowIdx}>
              {Array.from({ length: totalColumns }).map((_, colIdx) => (
                <td
                  key={colIdx}
                  className={cn(
                    "px-4 py-3 align-middle",
                    colIdx === totalColumns - 1 && ACTION_COL_WIDTH, // 👈 constrain body
                    tdClassName,
                  )}
                >
                  {/* ACTION COLUMN */}
                  {colIdx === totalColumns - 1 ? (
                    <div className="flex justify-center gap-2">
                      <div
                        data-testid="action-pill-skeleton"
                        className="h-5 w-10 bg-gray/30 rounded-full"
                      />
                      <div
                        data-testid="action-pill-skeleton"
                        className="h-5 w-10 bg-gray/30 rounded-full"
                      />
                      <div
                        data-testid="action-pill-skeleton"
                        className="h-5 w-10 bg-gray/30 rounded-full"
                      />
                    </div>
                  ) : (
                    <div
                      data-testid="cell-skeleton"
                      className="h-4 w-full bg-gray/30 rounded"
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableListingLoaders;
